import * as actions from "../../../../../../redux/actions/flowsActions";

export const onAddDelay = async (dispatch, axis, id) => {
  const newNodeId = Date.now().toString();

  const newNode = {
    id: newNodeId,
    type: "delay",
    data: { label: "Delay" },
    position: axis,
    fieldData: [],
    isUser: true,
  };

  const edge = {
    id: Date.now(),
    source: id,
    target: newNodeId,
    style: {
      strokeWidth: 2.2,
      stroke: "#566e8a",
    },
  };

  await dispatch({
    type: actions.CURRENT_NODE_ID,
    payload: { nodeId: newNodeId },
  });
  dispatch({ type: actions.ADD_NODE, payload: { newNode, nodeId: id } });
  dispatch({ type: actions.ADD_EDGE, payload: edge });
  dispatch({
    type: actions.EDIT_ELEMENT_IN_REDUX,
    payload: { openDelaySidebar: true },
  });
};
